export default "__VITE_ASSET__C3Bm4eJs__"